import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CreatePage.less';
import { bindActionCreators } from 'redux';
import * as actions from '../redux/actions';
import { connect } from 'react-redux';
import PageForm from './PageForm';
import { PAGE } from 'drapcode-constant';

export class CreatePage extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { projectId } = this.props;
    this.props.actions.getPermissionFlags({ projectId });
  }

  showCard = () => {
    return {
      display: !this.props.editor.showCreatePage ? 'none' : '',
    };
  };

  closeCard = () => {
    this.props.actions.toggleCreatePage();
    //?INFO: -> Commented code below to disable Builder Loader Screen
    // this.props.actions.hideBuilderLoader();
  };

  render() {
    const { editor, actions, projectId, version, pageId } = this.props;
    const {
      selectedPage,
      updatePagePending,
      createPagePending,
      deletePagePending,
      createPageSnapshotPending,
      permissionFlags,
      project,
      plugins,
      collections,
      pages,
      events,
      pageSnapshots,
      layouts,
      externalApis,
      snippets,
      snippetSnapshots,
    } = editor;
    let deleteFlag;
    if (permissionFlags && permissionFlags.length > 0) {
      deleteFlag = permissionFlags.includes(PAGE);
    }
    const page = selectedPage;
    if (!page) {
      return '';
    }
    const showPageCreateUpdateLoader = updatePagePending || createPagePending;
    const showPageDeleteLoader = deletePagePending;
    const showPageSnapshotCreateLoader = createPageSnapshotPending;
    return (
      <div className="gjs-mdl-container" style={this.showCard()}>
        <div className="gjs-mdl-dialog gjs-one-bg gjs-two-color">
          <div className="gjs-mdl-header">
            <div className="gjs-mdl-title">
              {page._id ? page.name + ' Settings' : 'Create New Page'}
            </div>
            <div className="gjs-mdl-btn-close" onClick={this.closeCard} data-close-modal="">
              ⨯
            </div>
          </div>
          <div className="gjs-mdl-content">
            <div id="gjs-mdl-c">
              <PageForm
                plugins={plugins}
                actions={actions}
                collections={collections}
                projectId={projectId}
                version={version}
                page={page}
                pages={pages}
                pageSnapshots={pageSnapshots}
                snippets={snippets}
                snippetSnapshots={snippetSnapshots}
                layouts={layouts}
                pageId={page.uuid}
                currentOpenPageId={pageId}
                showPageCreateUpdateLoader={showPageCreateUpdateLoader}
                showPageDeleteLoader={showPageDeleteLoader}
                showPageSnapshotCreateLoader={showPageSnapshotCreateLoader}
                project={project}
                events={events}
                externalApis={externalApis}
                flag={deleteFlag}
              />
            </div>
          </div>
          <div className="gjs-mdl-collector"></div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePage);
